import { render } from "./AttrGrid.vue?vue&type=template&id=2fe29724"
import script from "./AttrGrid.vue?vue&type=script&lang=js"
export * from "./AttrGrid.vue?vue&type=script&lang=js"

import "./AttrGrid.vue?vue&type=style&index=0&id=2fe29724&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fe29724"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fe29724', __exports__)) {
    api.reload('2fe29724', __exports__)
  }
  
  module.hot.accept("./AttrGrid.vue?vue&type=template&id=2fe29724", () => {
    api.rerender('2fe29724', render)
  })

}


export default __exports__